__turbopack_context__.v({
  "userCrumb": "UserCrumb-module__axhIIa__userCrumb",
});
